import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { Router } from '@angular/router';
import { compress } from 'lz-string';
import { CookieService } from 'ngx-cookie';
import { BehaviorSubject, startWith, map } from 'rxjs';
import { MaterialModule } from 'src/app/modules/material/material.module';
import { AlertService } from 'src/app/services/alert.service';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';
import { StorageService } from 'src/app/services/storage.service';
import { StoreService } from 'src/app/services/store.service';
import { environment } from 'src/environments/environment';

@Component({
	template: `
		<mat-nav-list>
			<a mat-list-item (click)="navigateToDeveloperPage()">
				<span mat-line>
					<div class="flex justify-center gap">
						<mat-icon>code</mat-icon>
						Developer Page
					</div>
				</span>
			</a>
			<a mat-list-item (click)="addPasswordSkipCookieToDomain()">
				<span mat-line>
					<div class="flex justify-center gap">
						<mat-icon>cookie</mat-icon>
						Skip Password Check With Cookie
					</div>
				</span>
			</a>
			<a mat-list-item (click)="deleteAndReload()">
				<span mat-line>
					<div class="flex justify-center gap">
						<mat-icon>delete_forever</mat-icon>
						Delete localStorage And Reload
					</div>
				</span>
			</a>
			<a mat-list-item (click)="clearCache()">
				<span mat-line>
					<div class="flex justify-center gap">
						<mat-icon>broken_image</mat-icon>
						Clear Images Cache
					</div>
				</span>
			</a>
		</mat-nav-list>
	`,
	selector: 'app-home-developer-buttons',
	styles: [``],
	standalone: true,
	imports: [ReactiveFormsModule, FormsModule, MaterialModule],
})
export class HomeDeveloperButtonsComponent {
	constructor(
		private _ss: StoreService,
		private _cookies: CookieService,
		private _fb: FormBuilder,
		public router: Router,
		private bottomSheetRef: MatBottomSheetRef<HomeDeveloperButtonsComponent>,
		private _bottomPopup: BottomPopupService,
		private _storage: StorageService,
		private _alert: AlertService,
	) {}

	openLink(event: MouseEvent) {
		this.bottomSheetRef.dismiss();
		event.preventDefault();
	}

	navigateToDeveloperPage() {
		this.router.navigate(['developer-info']);
		this.bottomSheetRef.dismiss();
	}

	addPasswordSkipCookieToDomain() {
		const domain = environment.production ? 'mobilityltd' : 'localhost';
		this._cookies.put('skipPassword', 'true', { domain });
		this._bottomPopup.show('Cookie Added', { action: 'Close', options: { verticalPosition: 'top' } });
	}

	async deleteAndReload() {
		await this._storage.clearAllSavedData();
		location.reload();
	}

	async clearCache() {
		caches
			.keys()
			.then(async function (names) {
				let bool = false;
				for (let name of names) {
					if (name.includes('images:cache') || name.includes('images:age')) {
						const cache = await caches.open(name);
						const allImagesCaches = await cache.keys();
						for (const image of allImagesCaches) {
							await cache.delete(image);
						}
						bool = true;
					}
				}
				if (!bool) {
					throw 'no images found';
				}
			})
			.then(() => {
				this._alert.customAlert('Images Cache Cleared');
			})
			.catch(err => {
				this._alert.customAlert('No Images Found');
				console.log(err);
			});
	}
}
